<template>
	<div class="message-box-mask" v-if="isVisible" @click="maskEvent ? mask() : ''">
		<div class="message-box" @click.stop>
			<div class="message-box-header">
				<i class="iconfont icon-fankui-weikaifang" :style="{color: iconColor}"></i>
				<span>{{ title }}</span>
			</div>
			<div class="message-box-body">
				<slot>
					<div class="message-html" v-html="message"></div>
				</slot>
			</div>
			<div class="message-box-footer">
				<button class="btn cancel" v-if="showCancel" @click="cancel">{{ cancelText }}</button>
				<button class="btn confirm" @click="confirm">{{ confirmText }}</button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'MessageBox',
		props: {
			title: {
				type: String,
				default: '提示'
			},
			message: {
				type: String,
				default: '消息内容'
			},
			confirmText: {
				type: String,
				default: '确定'
			},
			cancelText: {
				type: String,
				default: '取消'
			},
			visible: {
				type: Boolean,
				default: false
			},
			showCancel: {
				type: Boolean,
				default: true
			},
			maskEvent: {
				type: Boolean,
				default: true
			},
			iconColor: {
				type: String,
				default: '#0D68FF'
			}
		},
		data() {
			return {
				isVisible: this.visible
			};
		},
		watch: {
			visible(newVal) {
				this.isVisible = newVal;
			}
		},
		methods: {
			close() {
				this.isVisible = false;
				this.$emit('update:visible', false); // 触发父组件的更新
				this.$emit('close')
			},
			confirm() {
				this.isVisible = false;
				this.$emit('update:visible', false);
				this.$emit('confirm'); // 触发确认事件
			},
			cancel() {
				this.isVisible = false;
				this.$emit('update:visible', false);
				this.$emit('cancel'); // 触发取消事件
			},
			mask() {
				this.isVisible = false;
				this.$emit('update:visible', false);
				this.$emit('mask'); // 触发取消事件
			},
			handleMaskClick() {
				this.close();
			}
		}
	};
</script>

<style lang="scss" scoped>
	.message-box-mask {
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		background: rgba(0, 0, 0, 0.5);
		z-index: 9999;
	}

	.message-box {
		background: #fff;
		position: absolute;
		left: 50%;
		top: 40%;
		transform: translate(-50%, -50%);
		width: 400px;
		padding: 25px;
		border-radius: 5px;
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
		animation: message-box 0.3s forwards;
		transform: scale(0);
		opacity: 0;
	}

	@keyframes message-box {
		from {
			opacity: 0;
			transform: translate(-50%, -50%) scale(0);
		}

		to {
			opacity: 1;
			transform: translate(-50%, -50%) scale(1);
		}
	}

	.message-box-header {
		display: flex;
		align-items: center;

		.icon-fankui-weikaifang {
			font-size: 20px;
		}

		span {
			font-size: 18px;
			color: #333;
			margin-left: 10px;
		}
	}

	.message-box-body {
		margin: 20px 0;
		font-size: 16px;

		.message-html {
			margin-left: 30px;
			font-size: 14px;
			color: #666;
			line-height: 24px;
		}
	}

	.message-box-footer {
		display: flex;
		justify-content: flex-end;
		gap: 10px;
	}

	.message-box-footer {
		.btn {
			padding: 8px 25px;
			font-size: 14px;
			cursor: pointer;
			border-radius: 3px;
			border: 1px solid #ddd;
			color: #8C8C8C;
			background: 0;
		}

		.confirm {
			border: 1px solid #0D68FF;
			background: #0D68FF;
			color: #fff;
			transition: all 0.3s;

			&:hover {
				background: #1b8bff;
				border: 1px solid #1b8bff;
			}
		}
	}
</style>